import React from 'react'
import ReactSelect from 'react-select';
export default function LocationType({ setLocation, filter, location }) {
    return (
        <div>
            <h6>{filter?.title}</h6>
            <ReactSelect
                options={filter.values.map((value) => ({
                    value: value.id,
                    label: value.title,
                }))}
                onChange={(selectedOption) => {
                    setLocation(
                        [selectedOption]?.map((value) => ({
                            id: value.value,
                            title: value.label,
                        })),
                    );
                }}
                value={
                    Array.isArray(location)
                        ? location?.map((sort) =>
                            filter.values?.find((value) => value.id == sort.id)
                                ? {
                                    value: sort.id,
                                    label: filter.values.find(
                                        (value) => value.id == sort.id,
                                    )?.title,
                                }
                                : null,
                        )
                        : null
                }
                placeholder="Select option"
            />
        </div>
    )
}
